import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  modal: {
    position: 'absolute',
    zIndex: 4,
    top: '40%',
    left: '40%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalButtons: {
    display: 'flex',
    gap: spacing(16),
    justifyContent: 'flex-end',
  },
}))
